<template>
	<div @click.stop="cancel" class="popup-container">
		<div
			class="popup"
			ref="popup"
			:style="{
				left: `${menuX - width / 2}px`,
				top: `${menuY - height / 2}px`,
				transform: `scale(${1 / this.zoomScale})`,
				width: `${width}px`
			}"
			@click="cancel"
		>
			<header>
				<p class="title">
					{{ item.name }}
				</p>
			</header>
			<section>
				{{ item.instruction || $t('instruction_modal.default_instruction') }}
			</section>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: Object,
		menuX: Number,
		menuY: Number
	},
	data: () => ({
		height: 300,
		zoomScale: window.appState?.zoomLevel || 1
	}),
	computed: {
		scale() {
			return window.visualViewport.scale;
		},
		width() {
			return window.visualViewport.width < 300
				? window.visualViewport.width - window.visualViewport.width * 0.2
				: 300;
		}
	},
	methods: {
		cancel() {
			this.$emit('cancel');
		}
	},
	mounted() {
		this.height = this.$refs.popup.offsetHeight;
	}
};
</script>

<style lang="scss" scoped>
.popup-container {
  z-index: 10;
  pointer-events: all;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.popup {
  position: absolute;
  background: white;
  border: 1px solid lightgray;
  width: 300px;
  .title {
    font-size: 1em;
  }
}
</style>
